const PLAY_START_PLACE_NAMES = ['Adenrel', 'Narthia', 'Harolton'];
const OUTSKIRTS_OFFSET_FEET = 24;
const cross = (a, b) => a.x * b.z - a.z * b.x;
const subtract = (a, b) => ({ x: a.x - b.x, z: a.z - b.z });
const inside = (point, polygon) => {
  let result = false;
  for (let i = 0, j = polygon.length - 1; i < polygon.length; j = i++) {
    const a = polygon[i], b = polygon[j];
    if ((a.z > point.z) !== (b.z > point.z) &&
        point.x < (b.x - a.x) * (point.z - a.z) / (b.z - a.z) + a.x) result = !result;
  }
  return result;
};

// Roads are already classified and their coordinates normalized by the Play map.
// Intersect the actual town outline, rather than its bounding rectangle.
const buildSettlementStartLocation = ({ place, polygon, bounds, roads = [], side = 'south' }) => {
  const outline = polygon?.length >= 3 ? polygon : [
    { x: bounds.minX, z: bounds.minZ }, { x: bounds.maxX, z: bounds.minZ },
    { x: bounds.maxX, z: bounds.maxZ }, { x: bounds.minX, z: bounds.maxZ },
  ];
  const candidates = [];
  for (const road of roads) {
    for (let i = 1; i < road.points.length; i++) {
      const a = road.points[i - 1], direction = subtract(road.points[i], a);
      const length = Math.hypot(direction.x, direction.z);
      if (!length) continue;
      const unit = { x: direction.x / length, z: direction.z / length };
      for (let j = 0; j < outline.length; j++) {
        const b = outline[j], edge = subtract(outline[(j + 1) % outline.length], b);
        const denominator = cross(direction, edge);
        if (Math.abs(denominator) < 1e-8) continue;
        const delta = subtract(b, a);
        const t = cross(delta, edge) / denominator, u = cross(delta, direction) / denominator;
        if (t < 0 || t > 1 || u < 0 || u > 1) continue;
        const boundary = { x: a.x + direction.x * t, z: a.z + direction.z * t };
        const afterInside = inside({ x: boundary.x + unit.x * .1, z: boundary.z + unit.z * .1 }, outline);
        const beforeInside = inside({ x: boundary.x - unit.x * .1, z: boundary.z - unit.z * .1 }, outline);
        if (afterInside === beforeInside) continue; // Tangency is not an entrance.
        const outward = afterInside ? -1 : 1;
        const location = { x: boundary.x + unit.x * outward * OUTSKIRTS_OFFSET_FEET,
          z: boundary.z + unit.z * outward * OUTSKIRTS_OFFSET_FEET };
        if (!inside(location, outline)) candidates.push({ road, boundary, location });
      }
    }
  }
  candidates.sort((a, b) => side === 'north' ? a.boundary.z - b.boundary.z : b.boundary.z - a.boundary.z);
  const best = candidates[0];
  const name = place.name || place.entityName;
  return {
    source: best ? 'play2_settlement_road_entry' : 'play2_settlement_outskirts',
    label: best ? `${side === 'north' ? 'Northern' : 'Southern'} road into ${name}` : `Outskirts of ${name}`,
    ...(best ? { entrySide: side, roadId: best.road.idEntity, roadName: best.road.name } : {}),
    placeId: place.idEntity,
    placeName: name,
    location: {
      ...(best?.location || { x: bounds.minX - OUTSKIRTS_OFFSET_FEET, z: (bounds.minZ + bounds.maxZ) / 2 }),
      y: Number(place.location?.y) || 0,
      maxRadius: 5,
    },
  };
};

module.exports = { PLAY_START_PLACE_NAMES, buildSettlementStartLocation };
